import React, { useState } from "react";
import { History } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import api from "../lib/api";
import { toast } from "sonner";
import { ukDateTime } from "../lib/dates";

export const CellCallHistory = ({ recordId, name }) => {
  const [items, setItems] = useState(null);
  const open = () => api.get(`/cell/people/${recordId}/calls`).then(({ data }) => setItems(data)).catch(() => toast.error("Couldn't load call history"));
  return (
    <>
      <button type="button" data-testid={`cell-call-history-${recordId}`} onClick={open} title="Call & text history" className="p-2 rounded-lg hover:bg-[#E3F1EC]" style={{ color: "var(--sj-secondary)" }}><History className="h-4 w-4" /></button>
      <Dialog open={items !== null} onOpenChange={(o) => !o && setItems(null)}>
        <DialogContent className="max-w-md" data-testid="cell-call-history-dialog">
          <DialogHeader>
            <DialogTitle className="font-head text-xl">Cell Group calls & texts · {name}</DialogTitle>
            <DialogDescription>Calls and texts made through the app, with notes.</DialogDescription>
          </DialogHeader>
          {items && !items.length && <p className="text-sm" style={{ color: "var(--sj-text-3)" }} data-testid="cell-call-history-empty">No calls or texts yet.</p>}
          <ul className="space-y-2 max-h-80 overflow-y-auto">
            {(items || []).map((c) => (
              <li key={c.id} data-testid={`cell-call-history-item-${c.id}`} className="rounded-xl border p-3 text-sm" style={{ borderColor: "var(--sj-border)" }}>
                <div className="flex justify-between gap-2 text-xs" style={{ color: "var(--sj-text-3)" }}><span>{ukDateTime(c.created_at)} · {c.author}</span><span className="font-semibold" style={{ color: "var(--sj-primary)" }}>{c.outcome}</span></div>
                {c.note && <p className="mt-1 whitespace-pre-wrap break-words">{c.note}</p>}
              </li>
            ))}
          </ul>
        </DialogContent>
      </Dialog>
    </>
  );
};
